// helpers.test.js
import { _isMobile, _normalizeCurrency } from "@/pixels/utils/helpers";

describe("_isMobile", () => {
  it("returns true when userAgent indicates a mobile device", () => {
    Object.defineProperty(window.navigator, "userAgent", {
      value: "iPhone",
      configurable: true
    });
    expect(_isMobile()).toBe(true);
  });

  it("returns false when userAgent does not indicate a mobile device", () => {
    Object.defineProperty(window.navigator, "userAgent", {
      value: "Mozilla/5.0 (Windows NT 10.0; Win64; x64)",
      configurable: true
    });
    expect(_isMobile()).toBe(false);
  });
});

describe("_normalizeCurrency", () => {
  it("returns the standard currency code when given a non-standard code", () => {
    expect(_normalizeCurrency("dol")).toBe("USD");
  });

  it("returns the input as uppercase when given a standard currency code", () => {
    expect(_normalizeCurrency("usd")).toBe("USD");
  });

  it("returns the input as uppercase when given a non-mapped currency code", () => {
    expect(_normalizeCurrency("eur")).toBe("EUR");
  });

  it("returns an empty string when given an empty string", () => {
    expect(_normalizeCurrency("")).toBe("");
  });

  it("returns an empty string when given null", () => {
    expect(_normalizeCurrency(null)).toBe("");
  });
});
